module.exports = __webpack_public_path__ + "static/media/ultrasound.9358c900.jpeg";